import { useState } from 'react';
import "./gallery.css";
import { imagesMetadata } from '../../../imagesMetadata.js';

const galleryImagePaths = [
    "/static/images/tv-mounting-wall-art/prahran-picture-hanging-01.webp",
    "/static/images/installations/burwood-bathroom-mirror-installation-01.webp",
    "/static/images/commercial-maintenance/cheltenham-pop-up-store-setup-01.webp",
    "/static/images/installations/vermont-freestanding-mailbox-installation-01.webp",
    "/static/images/plastering-painting/berwick-garage-ceiling-plastering-01.webp",
    "/static/images/plastering-painting/clayton-timber-deck-painting-01.webp",
    "/static/images/plastering-painting/camberwell-timber-fence-painting-01.webp",
    "/static/images/plastering-painting/st-kilda-interior-hallway-painting-01.webp",
    "/static/images/plastering-painting/moorabbin-timber-deck-painting-01.webp",
    "/static/images/furniture-assembly/sandringham-ikea-pax-wardrobe-installation-01.webp",
    "/static/images/plastering-painting/heidelberg-commercial-exterior-painting-01.webp",
    "/static/images/carpentry/moonee-ponds-laundry-cupboard-shelving-01.webp",
    "/static/images/furniture-assembly/dingley-village-walk-in-robe-rod-installation-01.webp",
];

const images = galleryImagePaths
    .map((src) => {
        const meta = imagesMetadata[src] || {};
        return {
            src,
            alt: meta.alt || '',
            caption: meta.caption || meta.alt || '',
            location: meta.location || ''
        };
    });

const Gallery = () => {
    const [index, setIndex] = useState(0);

    const next = () => setIndex((i) => (i + 1) % images.length);
    const prev = () => setIndex((i) => (i - 1 + images.length) % images.length);

    if (!images.length) return null;

    return (
        <div className="gallery" role="region" aria-label="Recent handyman projects">
            <div className="gallery-slider">

                <div className="gallery-image">
                    <img 
                        src={images[index].src} 
                        alt="" 
                        className="bg-blur" 
                        aria-hidden="true" 
                    />
                    <img 
                        src={images[index].src} 
                        alt={images[index].alt} 
                        className="main-img" 
                    />
                </div>

                {images[index].caption && (
                    <div className="gallery-caption">
                        {images[index].caption}
                        <br />
                        {images[index].location && (
                            <div className="gallery-caption location">
                                {images[index].location}
                            </div>
                        )}
                    </div>
                )}

                <button type="button" className="nav-button left" onClick={prev} aria-label="Previous project" />
                <button type="button" className="nav-button right" onClick={next} aria-label="Next project" />

                <div className="gallery-dots">
                    {images.map((_, i) => (
                        <button
                            key={i}
                            className={`dot ${i === index ? "active" : ""}`}
                            onClick={() => setIndex(i)}
                            aria-label={`Show project ${i + 1} of ${images.length}`}
                            aria-current={i === index ? "true" : undefined}
                            type="button"
                        />
                    ))}
                </div>

            </div>
        </div>
    );
};

export default Gallery;
